export const TOTAL_COST_BREAKDOWN_FIELDS = [
    { name: "costRental", key: "rental", label: "Rental of Crane/Skylift" },
    { name: "costBankCharges", key: "bankCharges", label: "Bank Charges" },
    { name: "costReferralFee", key: "referralFee", label: "Referral Fees" },
];

const toAmount = (value) => {
    if (value === "" || value === null || value === undefined) return null;
    const amount = parseFloat(value);
    return Number.isFinite(amount) ? amount : null;
};

export const getTotalCostBreakdownInputs = (order) =>
    TOTAL_COST_BREAKDOWN_FIELDS.reduce((acc, { name, key }) => {
        acc[name] = order?.totalCostBreakdown?.[key] ?? "";
        return acc;
    }, {});

export const buildTotalCostBreakdown = (inputs) =>
    TOTAL_COST_BREAKDOWN_FIELDS.reduce((acc, { name, key }) => {
        acc[key] = toAmount(inputs?.[name]);
        return acc;
    }, {});

export const getTotalCostBreakdownSum = (inputs) => {
    const amounts = Object.values(buildTotalCostBreakdown(inputs)).filter(
        (amount) => amount !== null
    );
    if (amounts.length === 0) return null;
    return Math.round(amounts.reduce((sum, amount) => sum + amount, 0) * 100) / 100;
};
